module.exports = __webpack_public_path__ + "media/gold.a7e7b958.mp3";